module.exports = __webpack_public_path__ + "img/AFMS_FATIGUE.e30b5399.png";